
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './styles/ResetPassword.module.css';
import Logo from '../assets/cp365v.png';
import { Toaster, toast } from 'react-hot-toast';

import { api } from '../api.js';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const {state} = useLocation();


    // If state is available, set the OTP value
    const otp = state?.otp || '';


  const handleSubmit = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      toast('Passwords do not match', { type: 'error' });
      return;
    }

    try {
      const response = await api.patch(
        `/users/password/reset`,
        {otp, password },
      );

      if (response && response.data) {

        if (response.data.status === true) {
          toast('Password reset successfully!', { type: 'success' });
          // You can navigate to the success page or perform other actions here
          navigate('/success');
        } else {
          toast(response.data.message || 'Password reset failed', {
            type: 'error',
          });
        }
      } else {
        console.error('Invalid response format');
      }
    } catch (error) {
      console.error('Error:', error);

      toast(
        error.response?.data?.message || 'An error occurred during password reset',
        { type: 'error' },
      );
    }
  };

  return (
    <div className={styles.wrapper}>
      <Toaster position="top-center" reverseOrder={false}></Toaster>
      <div className={styles.logo}>
        <img src={Logo} alt="logo" />
      </div>
      <div className={styles.header}><h2>Reset Password</h2></div>
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.header}>
          <h4>Enter New Password</h4>
        </div>
        <div className={styles.inputdiv}>
          <input
            type="text"
            placeholder="Enter new password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <div className={styles.header}>
          <h4>Confirm Password</h4>
        </div>
        <div className={styles.inputdiv}>
          <input
            type="text"
            placeholder="Confirm new password"
            className={styles.input}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>
        <div className={styles.btndiv}>
          <button className={styles.btn} type="submit">
            Reset Password
          </button>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;

